(() => {
  'use strict';

  const form = document.querySelector('#rose-cart-form');
  if (!form) return;

  const refillId = '58641264509192';
  const refillPrice = Number(form.dataset.roseRefillPrice) / 100;
  const applicatorPrice = Number(form.dataset.roseApplicatorPrice) / 100;
  const applicators = new Map([
    ['50001277321480', 'Black Sand Beach'],
    ['50001277354248', 'Manarola Rosé'],
    ['50001277387016', 'Vert Forillon'],
    ['53287523942664', 'Malva']
  ]);
  const money = amount => `CHF ${amount}.–`;
  const quantity = document.querySelector('#rose-quantity');
  const minus = document.querySelector('#rose-minus');
  const plus = document.querySelector('#rose-plus');
  const colorChoice = document.querySelector('#rose-color-pick');
  const cartItems = document.querySelector('#rose-cart-items');
  const offers = [...form.querySelectorAll('input[name="rose-offer"]')];
  const colors = [...form.querySelectorAll('input[name="rose-color"]')];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function hidden(name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = String(value);
    return input;
  }

  function updatePurchase() {
    const count = Math.min(20, Math.max(1, Math.trunc(Number(quantity.value) || 1)));
    const kit = form.querySelector('input[name="rose-offer"]:checked')?.value === 'kit';
    const selectedColor = form.querySelector('input[name="rose-color"]:checked');
    const colorName = applicators.get(selectedColor?.value) || 'Manarola Rosé';
    const total = count * refillPrice + (kit ? applicatorPrice : 0);
    quantity.value = String(count);
    minus.disabled = count <= 1;
    plus.disabled = count >= 20;
    colorChoice.hidden = !kit;
    offers.forEach(input => input.closest('.rose-offer').classList.toggle('is-selected', input.checked));
    colors.forEach(input => input.closest('.rose-color').classList.toggle('is-selected', input.checked));
    document.querySelector('#rose-selected-color').textContent = colorName;

    const lines = [hidden('items[0][id]', refillId), hidden('items[0][quantity]', count)];
    if (kit && selectedColor && applicators.has(selectedColor.value)) {
      lines.push(hidden('items[1][id]', selectedColor.value), hidden('items[1][quantity]', 1));
    }
    cartItems.replaceChildren(...lines);

    const refillLabel = `${count} ${count === 1 ? 'recharge' : 'recharges'} Le Rose`;
    document.querySelector('#rose-selection-summary').textContent = kit ? `${refillLabel} + 1 applicateur ${colorName}` : refillLabel;
    document.querySelector('#rose-selection-price').textContent = money(total);
    document.querySelector('#rose-impact-value').textContent = `${money(count * 5)} reversés à OSE après ton achat`;
    document.querySelector('#rose-add-label').textContent = kit ? 'Ajouter mon kit' : count === 1 ? 'Ajouter ma recharge' : 'Ajouter mes recharges';
    document.querySelector('#rose-total').textContent = money(total);
    document.querySelector('#rose-sticky-choice').textContent = kit ? `Le Rose · kit ${colorName}` : `Le Rose · ${count} ${count === 1 ? 'recharge' : 'recharges'}`;
    document.querySelector('#rose-sticky-price').textContent = money(total);
  }

  offers.forEach(input => input.addEventListener('change', updatePurchase));
  colors.forEach(input => input.addEventListener('change', updatePurchase));
  minus.addEventListener('click', () => { quantity.value = String(Number(quantity.value) - 1); updatePurchase(); });
  plus.addEventListener('click', () => { quantity.value = String(Number(quantity.value) + 1); updatePurchase(); });
  quantity.addEventListener('input', updatePurchase);
  quantity.addEventListener('change', updatePurchase);
  form.addEventListener('submit', updatePurchase);
  updatePurchase();

  const thumbs = [...document.querySelectorAll('.pdp-thumb')];
  const photo = document.querySelector('#rose-main-photo');
  let photoIndex = 0;
  function showPhoto(index) {
    const nextIndex = (index + thumbs.length) % thumbs.length;
    if (nextIndex === photoIndex) return;
    photoIndex = nextIndex;
    (window.BasicProductImages ? window.BasicProductImages.setImage(photo, thumbs[nextIndex].dataset.src) : (photo.removeAttribute('srcset'), photo.src = thumbs[nextIndex].dataset.src));
    photo.alt = thumbs[nextIndex].dataset.alt;
    thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === nextIndex);
      thumb.setAttribute('aria-pressed', String(i === nextIndex));
    });
  }
  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showPhoto(index)));
  document.querySelector('#rose-photo-prev').addEventListener('click', () => showPhoto(photoIndex - 1));
  document.querySelector('#rose-photo-next').addEventListener('click', () => showPhoto(photoIndex + 1));
  let touchX = null;
  const mainImage = document.querySelector('#rose-main-image');
  mainImage.addEventListener('touchstart', event => { touchX = event.changedTouches[0].screenX; }, {passive:true});
  mainImage.addEventListener('touchend', event => {
    if (touchX === null) return;
    const difference = event.changedTouches[0].screenX - touchX;
    if (Math.abs(difference) > 45) showPhoto(photoIndex + (difference < 0 ? 1 : -1));
    touchX = null;
  }, {passive:true});

  const sticky = document.querySelector('#pdp-mobile-buy');
  const closing = document.querySelector('.rose-closing');
  function updateSticky() {
    const passedPurchase = form.getBoundingClientRect().bottom < 82;
    const nearEnd = closing.getBoundingClientRect().top < window.innerHeight * .82;
    const visible = window.innerWidth <= 700 && passedPurchase && !nearEnd && !document.body.classList.contains('menu-locked');
    sticky.classList.toggle('is-visible', visible);
    sticky.setAttribute('aria-hidden', String(!visible));
    sticky.inert = !visible;
  }
  window.addEventListener('scroll', updateSticky, {passive:true});
  window.addEventListener('resize', updateSticky);
  new MutationObserver(updateSticky).observe(document.body, {attributes:true,attributeFilter:['class']});
  updateSticky();

  const revealSections = document.querySelectorAll('.rose-reveal');
  if ('IntersectionObserver' in window && !reducedMotion) {
    const revealObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in-view');
        revealObserver.unobserve(entry.target);
      });
    }, {threshold: .12});
    revealSections.forEach(section => revealObserver.observe(section));
  }

  // Le montant affiché provient du compteur recalculé par Shopify Flow.
  const donationTotal = document.querySelector('#rose-donation-total');
  const donationAnnouncement = document.querySelector('#rose-donation-announcement');
  const goalCurrent = document.querySelector('#rose-goal-current');
  const goalRemaining = document.querySelector('#rose-goal-remaining');
  const goalTrack = document.querySelector('#rose-goal-track');
  const goalFill = document.querySelector('#rose-goal-fill');
  const goalMarkers = [...document.querySelectorAll('.rose-goal-markers [data-goal]')];
  const goals = [500, 1000, 2000, 3000, 4000, 5000];
  let displayedDonation = 0;
  const donationMoney = amount => `CHF ${amount.toLocaleString('fr-CH')}.–`;
  function showGoal(amount) {
    const next = goals.find(goal => amount < goal);
    const previousGoal = goalCurrent.textContent;
    goalCurrent.textContent = next ? donationMoney(next) : 'Objectif CHF 5’000 atteint';
    goalRemaining.textContent = next
      ? `Encore ${donationMoney(next - amount)} pour atteindre ce palier.`
      : 'Chaque nouvelle recharge continue de soutenir OSE Thérapies.';
    goalTrack.setAttribute('aria-valuenow', String(Math.min(amount, 5000)));
    goalTrack.setAttribute('aria-valuetext', next
      ? `${donationMoney(amount)} générés sur CHF 5’000. Prochain objectif : ${donationMoney(next)}.`
      : `${donationMoney(amount)} générés. Objectif final de CHF 5’000 atteint.`);
    goalFill.style.width = `${Math.min(amount, 5000) / 50}%`;
    goalMarkers.forEach(marker => {
      const milestone = Number(marker.dataset.goal);
      marker.classList.toggle('is-reached', amount >= milestone);
      marker.classList.toggle('is-current', milestone === next);
    });
    if (previousGoal !== goalCurrent.textContent && !reducedMotion) {
      goalCurrent.classList.remove('is-changing');
      void goalCurrent.offsetWidth;
      goalCurrent.classList.add('is-changing');
    }
  }
  function showVerifiedDonation(amount) {
    if (amount === displayedDonation) return;
    displayedDonation = amount;
    donationTotal.textContent = donationMoney(amount);
    donationTotal.dataset.size = amount >= 100000 ? 'condensed' : amount >= 1000 ? 'compact' : 'normal';
    showGoal(amount);
    donationAnnouncement.textContent = `Cagnotte : ${donationMoney(amount)}`;
    if (!reducedMotion) {
      donationTotal.classList.remove('is-updated');
      void donationTotal.offsetWidth;
      donationTotal.classList.add('is-updated');
    }
  }
  showGoal(0);
  async function updateDonationCounter() {
    if (!donationTotal) return;
    try {
      let data;
      if (window.BasicShopifyConfig) {
        const endpoint = new URL(window.location.pathname, window.location.origin);
        endpoint.searchParams.set('section_id', 'basic-rose-counter');
        endpoint.searchParams.set('_counter', String(Date.now()));
        const response = await fetch(endpoint.href, {cache:'no-store'});
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const payload = html.querySelector('#rose-campaign-data');
        if (!payload) return;
        data = JSON.parse(payload.textContent);
      } else {
        const response = await fetch('rose-campaign-status.json', {cache:'no-store'});
        if (!response.ok) return;
        data = await response.json();
      }
      const amount = Number(data.generatedDonationChf);
      const checked = new Date(data.asOf);
      if (data.campaign !== 'le-rose-ose-2026' || !Number.isInteger(amount) || amount < 0 || amount % 5 !== 0 || Number.isNaN(checked.getTime())) return;
      showVerifiedDonation(amount);
    } catch (_) {
      // Le dernier montant affiché reste disponible si la requête échoue.
    }
  }
  updateDonationCounter();
  window.setInterval(updateDonationCounter, 120000);
})();

